import React from "react";

const Hero = (props) => {
    return (
        <div className="relative h-40">

            <div className="w-full z-0 top-0 absolute h-40 bg-cover bg-[url('/src/images/movie.jpg')] ">
                <div className="w-full h-full bg-gradient-to-b from-pink-800 via-pink-700 to-purple-600 opacity-60">

                </div>
            </div>
            <div className="container relative">
                <h1 className="text-white text-4xl pt-8">Movie Findr</h1>
                <p className="text-gray-100 text-md pt-4">Home | <span className="text-gray-300 text-md pt-4 z-50">Results</span></p>
            </div>
        </div>
    );
}

export default Hero;